/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../environments/environment';
import { Observable, map, of, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private baseUrl = environment.apiUrl;
  private termsAccepted: boolean | null = null;

  constructor(private http: HttpClient) {}

  login(loginData: any) {
    const body = new HttpParams()
      .set('grant_type', 'password')
      .set('username', loginData.username)
      .set('password', loginData.password)
      .set('isDocSend', loginData.isDocSend !== undefined ? String(loginData.isDocSend) : 'true');

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
    });

    return this.http.post(`${this.baseUrl}/login`, body.toString(), {
      headers,
    });
  }

  getStartUpInfo(): Observable<any> {
    return this.http.get(`${this.baseUrl}/utente/getstartupinfo`).pipe(
      tap((res: any) => {
        this.termsAccepted = res.uiConfig?.contrattiDrawerOpen ?? false;
      }),
    );
  }

  getConditionsTrackingStatus(codImpresa: string, conditionDescription: string): Observable<any> {
    const params = new HttpParams()
      .set('codImpresa', codImpresa)
      .set('conditionDescription', conditionDescription);

    return this.http.get(`${this.baseUrl}/utente/conditionstracking/status`, {
      params,
    });
  }

  saveConditionsTracking(payload: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/utente/conditionstracking`, payload);
  }

  patchConditionsTracking(id: number | string, payload: any): Observable<any> {
    return this.http.patch(`${this.baseUrl}/utente/conditionstracking/${id}`, payload);
  }

  isTermsAccepted(): Observable<boolean> {
    if (this.termsAccepted !== null) {
      return of(this.termsAccepted);
    }
    if (sessionStorage.getItem('token') === null) {
      return of(false);
    }
    return this.getStartUpInfo().pipe(map(() => !!this.termsAccepted));
  }

  saveStartupInfo(startupInfo: any) {
    return this.http
      .put(`${this.baseUrl}/utente/saveuiconfig`, startupInfo)
      .pipe(
        tap(() => {
          if (startupInfo.contrattiDrawerOpen) {
            this.termsAccepted = true;
          }
        }),
      );
  }

  logout() {
    sessionStorage.removeItem('token');
    this.termsAccepted = null;
  }

  requestResetPassword(userName: any) {
    return this.http.get(`${this.baseUrl}/utente/recuperapassword/${userName}`);
  }

  changePassword(changePasswordData: any) {
    return this.http.put(
      `${this.baseUrl}/utente/changepassword`,
      changePasswordData,
    );
  }
}
